module.exports = __webpack_public_path__ + "08_long_black.3674ce27.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/08_long_black.png
// module id = 9+13
// module chunks = 0